import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-copy-paste-menu-item',
  templateUrl: './copy-paste-menu-item.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyPasteMenuItemComponent implements OnInit {
  @Input() allowCopyAll: boolean = false;
  @Input() showCopy: boolean = true;
  @Input() readonly: boolean = false;
  @Output() onCopy = new EventEmitter<any>();
  @Output() onPaste = new EventEmitter<any>();
  @Output() onClipboardPaste = new EventEmitter<any>();
  @Output() onCopyAll = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

}
